import { Eye } from "feather-icons-react/build/IconComponents";

export const policyColumns = [
  {
    accessorKey: "submission_number",
    header: "Submission Number",
    enableSorting: true,
  },
  {
    accessorKey: "Company Name",
    header: "Company Name",
    enableSorting: true,
  },
  {
    accessorKey: "effective_date",
    header: "Effective Date",
    enableSorting: true,
  },
  {
    accessorKey: "carrier",
    header: "Carrier",
    enableSorting: true,
  },
  {
    accessorKey: "Premium",
    header: "Premium",
    enableSorting: true,
  },
  {
    accessorKey: "status",
    header: "Status",
    enableSorting: true,
    cell: ({ row }) => {
      const status = row.original.status;

      let colorClasses = "bg-gray-100 text-gray-800";

      if (status === "active") {
        colorClasses = "bg-green-100 text-green-800";
      } else if (status === "pending cancelation") {
        colorClasses = "bg-yellow-100 text-yellow-800";
      } else if (status === "rejected") {
        colorClasses = "bg-red-100 text-red-800";
      } else if (status === "canceled") {
        colorClasses = "bg-gray-100 text-gray-800";
      }

      return (
        <span
          className={`
            inline-flex items-center px-2.5 py-0.5 rounded-md font-medium ${colorClasses}
          `}
        >
          {status.charAt(0).toUpperCase() + status.slice(1)}
        </span>
      );
    },
  },
  {
    id: "actions",
    header: "Actions",
    cell: ({ row }) => {
      return (
        <button
          onClick={() => row.original.handleView(row.original)}
          className="text-gray-400 hover:text-gray-600"
        >
          <Eye size={20} />
        </button>
      );
    },
  },
];
